<template>
  <v-overlay
    class="d-flex flex-column align-center justify-center"
    persistent
    @click:outside="
      () => {
        if (btnText === 'OK' || btnText === 'Ok') {
          onHide();
        }
      }
    "
    v-model="show"
    :close-delay="0"
    no-click-animation
  >
    <v-card
      class="overflow-visible position-relative rounded-xl"
      max-width="400px"
      min-width="280px"
      width="95vw"
    >
      <v-icon
        size="100"
        ck
        style="
          position: absolute;
          left: 50%;
          top: 0%;
          cursor: pointer;
          border-radius: 50%;
          transform: translate(-50%, -50%);
        "
        class="mb-3 bg-background"
        :icon="getIcon()"
        :color="getDialogActionsColor()"
      ></v-icon>

      <v-container
        class="bg-transparent pa-4 pa-sm-5 pt-14 pt-sm-14 text-center d-flex flex-column align-center custom-scroll-container"
        style="max-height: 90vh"
      >
        <!-- <v-icon
          size="60"
          class="mb-3"
          :icon="getIcon()"
          :color="getDialogActionsColor()"
        ></v-icon> -->
        <p style="font-size: 19px; font-weight: 600" class="mb-3">
          {{ title }}
        </p>
        <div style="flex: 1 1 !important" class="text-center mb-5">
          <p class="text-body-1">
            {{ message }}
          </p>
        </div>

        <v-row no-gutters class="w-100" style="gap: 10px">
          <v-btn
            style="flex-basis: 150px; flex-grow: 1; flex-shrink: 1"
            :loading="isLoading"
            :class="{ 'text-uppercase': btnText === 'OK' || btnText === 'Ok' }"
            :color="getDialogActionsColor()"
            @click="onAction"
            variant="elevated"
            >{{ btnText }}</v-btn
          >

          <v-btn
            v-if="!(btnText === 'OK' || btnText === 'Ok')"
            style="flex-basis: 150px; flex-grow: 1; flex-shrink: 1"
            :disabled="isLoading"
            @click="onHide"
            variant="tonal"
          >
            Cancel
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-overlay>
</template>
<script lang="ts" setup>
import { DialogType } from "~/core/enums";

const props = defineProps<{
  type: DialogType;
  title: string;
  message: string;
  onAction: Function;
  onHide: () => void;
  btnText: string;
  icon?: string;
}>();

const show = defineModel<boolean>("show", { required: true });
const isLoading = defineModel<boolean>("isLoading", { required: true });

function getIcon(): string {
  if (props.icon) return props.icon;
  switch (props.type) {
    case DialogType.error:
      return "mdi-close-circle";
    case DialogType.success:
      return "mdi-check-circle";
    case DialogType.info:
      return "information-slab-circle";
    case DialogType.action:
      return "mdi-check-circle";
    case DialogType.alert:
      return "mdi-alert";
    default:
      return "mdi-check-circle";
  }
}

function getDialogActionsColor(): string {
  switch (props.type) {
    case DialogType.error:
      return "error";
    case DialogType.success:
      return "primary";
    case DialogType.info:
      return "info";
    case DialogType.action:
      return "secondary";
    case DialogType.alert:
      return "warning";
    default:
      return "secondary";
  }
}
</script>
